import { combineReducers } from 'redux';

import currentProcessingDocumentId from './currentProcessingDocumentId';
import error from './error';
import failedDocuments from './failedDocuments';
import loadingStatuses from './loadingStatuses';
import processCount from './processCount';

export default combineReducers({
  currentProcessingDocumentId,
  error,
  failedDocuments,
  loadingStatuses,
  processCount,
});
